export const SYNC_HOT_UPDATE = '@@hotUpdate/sync'
